// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__542a0","author":"Table_author__2V-OU","authorImage":"Table_authorImage__1Ev5e","unreadRow":"Table_unreadRow__2r-gu"};